import { useEffect, useState } from 'react';
import { Transition, useScroll, Variants } from 'framer-motion';

// navigation scroll logic
export const useIsStickyMode = (withoutHeader) => {
  const [isStickyMode, setIsStickyMode] = useState(false);
  const { scrollY } = useScroll();
  const navigationTransition: Transition = { duration: 0.5 };

  const _withoutHeader = withoutHeader === false ? 46 : 0;
  const navigationVariants: Variants = {
    scrollUp: {
      top: _withoutHeader,
    },
    scrollDown: {
      top: -66,
    },
  };

  useEffect(() => {
    return scrollY.onChange((current) => {
      const prev = scrollY.getPrevious();
      if (current > prev) {
        setIsStickyMode(false);
      } else if (current < prev) {
        setIsStickyMode(true);
      }
    });
  }, []);

  return { isStickyMode, navigationVariants, navigationTransition };
};
